import * as client_hooks from '../../../src/hooks.client.js';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32')
];

export const server_loads = [];

export const dictionary = {
		"/(loggedout)": [24,[3]],
		"/(public)/c/[circuitUuid]": [28,[4]],
		"/(public)/events": [30,[4]],
		"/(public)/e/[shortId]": [29,[4]],
		"/(tv)/e/[shortId]/tv": [32,[5]],
		"/(loggedout)/forgot-password": [25,[3]],
		"/(public)/home": [31,[4]],
		"/(loggedout)/login": [26,[3]],
		"/(loggedin)/player/events/[eventUuid]": [6,[2]],
		"/(loggedin)/profile": [7,[2]],
		"/(loggedin)/rankings": [8,[2]],
		"/(loggedout)/register": [27,[3]],
		"/(loggedin)/select-venue": [9,[2]],
		"/(loggedin)/venue/[venueUuid]/admins": [10,[2]],
		"/(loggedin)/venue/[venueUuid]/circuits": [11,[2]],
		"/(loggedin)/venue/[venueUuid]/circuits/[circuitUuid]": [12,[2]],
		"/(loggedin)/venue/[venueUuid]/events": [13,[2]],
		"/(loggedin)/venue/[venueUuid]/events/[eventUuid]": [14,[2]],
		"/(loggedin)/venue/[venueUuid]/live": [15,[2]],
		"/(loggedin)/venue/[venueUuid]/payments": [16,[2]],
		"/(loggedin)/venue/[venueUuid]/planning": [17,[2]],
		"/(loggedin)/venue/[venueUuid]/player-claims": [18,[2]],
		"/(loggedin)/venue/[venueUuid]/players": [19,[2]],
		"/(loggedin)/venue/[venueUuid]/rankings": [20,[2]],
		"/(loggedin)/venue/[venueUuid]/settings": [21,[2]],
		"/(loggedin)/venue/[venueUuid]/tournaments": [22,[2]],
		"/(loggedin)/venue/[venueUuid]/tournaments/[tournamentUuid]": [23,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';